<template>
    <div class="insurance-info">
        <QS-h4-title title="投保信息" />
        <el-tabs v-model="activeName">
            <el-tab-pane label="投保方案" name="schema">
                <insuranceCompanyList
                  :list="
                    orderDetail.insuranceCompareUnderwritingOrderVOList
                    "
                  :orderStatus="orderDetail.status"
                />
            </el-tab-pane>
            <el-tab-pane label="支付信息" name="payInfo">
                <QS-column-box
                    :source="payInfoSource"
                    :list="payInfoList"
                    separator=":"
                >
                  <template slot="paymentVoucher" slot-scope="scope">
                    <el-button
                      type="text"
                      @click="previewImg(payInfoSource[scope.key])"
                    >
                      查看
                    </el-button>
                  </template>
                </QS-column-box>
            </el-tab-pane>
            <el-tab-pane label="保单及电子发票" name="policyAndInvoice">
                <QS-column-box
                    :source="policyAndInvoiceSource"
                    :list="policyAndInvoiceList"
                    separator=":"
                >
                  <template
                    v-for="item in policyAndInvoiceList"
                    v-slot:[`${item.key}`]="{ key }"
                  >
                    <span v-if="key !== 'remark'" :key="item.key">
                      <el-link
                        v-if="policyAndInvoiceSource[key] !== null"
                        :href="policyAndInvoiceSource[key]"
                        :underline="false"
                        type="primary"
                        target="_blank"
                      >查看</el-link>
                      <span v-else>--</span>
                    </span>
                    <span v-else :key="item.key">{{ policyAndInvoiceSource[key] }}</span>
                  </template>
                </QS-column-box>
            </el-tab-pane>
        </el-tabs>
        <ImageView
            v-if="imageView.show"
            :imgViewShow="imageView.show"
            :imgList="[imageView.img]"
            @closeImgView="imageView.show = false"
        />
    </div>
</template>

<script setup>
import { ref, toRefs, computed } from 'vue'
import insuranceCompanyList from './insuranceCompanyList.vue'
import ImageView from '@/components/UploadCommon/components/ImageView.vue'

const props = defineProps({
  orderDetail: {
    type: Object,
    default: () => {},
  },
  orderTabDetail: {
    type: Object,
    default: () => {},
  },
})

const { orderDetail, orderTabDetail } = toRefs(props)

const activeName = ref('schema')

const imageView = ref({
  show: false,
  img: '',
})

// 支付信息
const payInfoList = [
  {
    key: 'paymentVoucher',
    name: '支付凭证',
  },
]

const payInfoSource = computed(() => {
  return {
    paymentVoucher: orderTabDetail.value.paymentVoucher,
  }
})

// 保单及电子发票
const policyAndInvoiceList = [
  {
    key: 'compulsoryInsuranceDocument',
    name: '交强险保单',
  },
  {
    key: 'commercialInsuranceDocument',
    name: '商业险保单',
  },
  {
    key: 'electronicInvoice',
    name: '电子发票',
  },
  {
    key: 'remark',
    name: '备注',
  },
]

const policyAndInvoiceSource = computed(() => {
  return {
    compulsoryInsuranceDocument: orderTabDetail.value.compulsoryInsuranceDocument,
    commercialInsuranceDocument: orderTabDetail.value.commercialInsuranceDocument,
    electronicInvoice: orderTabDetail.value.electronicInvoice,
    remark: orderTabDetail.value.remark,
  }
})

const previewImg = (img) => {
  imageView.value.img = img
  imageView.value.show = true
}

</script>

<style lang="scss" scoped>
.insurance-info {
    margin-top: 16px;
}
</style>
